// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(true);
// Module
exports.push([module.id, ".InsertNewCategoryLabelWidth{width:58px !important}.InsertNewCategoryLabelWidthForDisplay{width:100px !important}\n", "",{"version":3,"sources":["/home/sysadmin/apps/rsee-panel/src/screens/menuCategories/styles.scss"],"names":[],"mappings":"AAAA,6BACE,qBAAsB,CACvB,uCAEC,sBAAuB","file":"styles.scss","sourcesContent":[".InsertNewCategoryLabelWidth{\n  width: 58px !important;\n}\n.InsertNewCategoryLabelWidthForDisplay{\n  width: 100px !important;\n}"]}]);
// Exports
module.exports = exports;
